import * as React from 'react';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import Flower from './flower';

interface StyleProps {
  type?: string;
  shape?: string;
}


const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin-top: 50px;
  padding: 20px 0 90px 0;
  box-shadow: 3px 10px 60px rgba(0,0,0,.3);
  z-index: 1;
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 105px 25px 35px;
  width: 160px;
  min-height: 176px;
  font-size: 18px;
  font-weight: bold;
  background: url(${require('../../assets/location/title_bg@2x.png')}) 0 0 no-repeat;
  background-size: 160px;
  text-align: center;
`;

const GiftTab = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;

const GiftBtn = styled.button<StyleProps>`
  padding-top: 40px;
  width: 100px; height: 76px;
  background: url(${props => require(`../../assets/gift/gift_${props.shape}@2x.png`)}) center 0 no-repeat;
  background-size: auto 36px;
`;

const Section = styled.div`
  display: block;
  position: relative;
  margin-top: 30px;
  padding: 0 0 70px 0;
  width: 100%;
  text-align: center;
  z-index: 10;
  & select {
    font-size: 20px;
    text-align: center;
  }
`;

const btnStyle = css`
  display: inline-block;
  padding: 0 10px;
  height: 24px;
  line-height: 22px;
  font-size: 12px;
  border: 1px solid #a8988a;
  border-radius: 10px;
  background: #fff;
  vertical-align: top;
`;

const BtnCopy = styled.button`
  ${btnStyle}
  height: 36px;
  line-height: 34px; 
  font-size: 16px;
`;

const GiftSend = styled.a`
  ${btnStyle}
  margin-top: 30px;
  height: 36px;
  line-height: 34px; 
  font-size: 16px;
`;

const TossApp = styled.a`
  display: block;
  position: absolute;
  bottom: 0; left: 25px;
  padding: 0 0 0 35px;
  height: 26px; line-height: 24px;
  color: #0050ff;
  background: url(${require(`../../assets/gift/gift_toss@2x.png`)}) 0 0 no-repeat;
  background-size: 30px auto;
`;

const HuobiLink = styled.a`
  display: block;
  position: absolute;
  bottom: 0; left: 25px;
  padding: 0 0 0 25px;
  height: 26px; line-height: 24px;
  color: #0050ff;
  background: url(${require(`../../assets/gift/gift_ht@2x.png`)}) 0 0 no-repeat;
  background-size: auto 26px;
`; 

const CoinWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & p {
    padding: 20px;
    word-break: break-all;
  }
`;

const Qrcode = styled.div`
  margin-top: 20px;
`;

interface IProps {
  messages?: any;
  lang?: string;
}

const Toss = ({ messages }: any) => {

  const tossDefault = {
    bankName: '신한',
    bankAccountNo: '110303516357',
    amount: '50000',
  }

  const [tossState, tossSet] = useState(tossDefault);

  const changeToss = (value: any) => {
    tossSet({
      ...tossDefault,
      amount: value
    })
  }
  return (
    <>
      <select onChange={event => changeToss(event.target.value)}>
        <option value="50000">50,000</option>
        <option value="60000">60,000</option>
        <option value="70000">70,000</option>
        <option value="80000">80,000</option>
        <option value="90000">90,000</option>
        <option value="100000">100,000</option>
        <option value="150000">150,000</option>
        <option value="200000">200,000</option>
        <option value="300000">300,000</option>
        <option value="400000">400,000</option>
        <option value="500000">500,000</option>
        <option value="1000000">1,000,000</option>
        <option value="1500000">1,500,000</option>
        <option value="2000000">2,000,000</option>
        <option value="2500000">2,500,000</option>
        <option value="3500000">3,500,000</option>
      </select>
      <br/>
      <GiftSend href={`supertoss://send?bank=${tossState.bankName}&accountNo=${tossState.bankAccountNo}&origin=linkgen&amount=${tossState.amount}`}>{messages.moneySend}</GiftSend>
      <TossApp href="https://toss.im/_m/9Cfhmsj2">{messages.tossAppSet}</TossApp>
    </>
  )
}

const Coin = ({ lang, messages, coinname, qrcode }: any) => {
  const Clipboard = require('clipboard');
  new Clipboard('.btn');

  return (
    <CoinWrap>
      <h2>{coinname.toUpperCase()} {messages.deposit}</h2>
      <Qrcode>
        <img src={require(`../../assets/gift/qrcode_${coinname}.png`)} alt={coinname + 'qrcode image'} />
      </Qrcode>
      <p id="qrcode">{qrcode}</p>
      <BtnCopy className="btn" data-clipboard-target="#qrcode">{messages.copy}</BtnCopy>
      <HuobiLink href={lang === 'ko-KR' ? 'https://www.huobi.co.kr/' : 'https://www.hbg.com'} target="_blank">{messages.huobi}</HuobiLink>
    </CoinWrap>
  )
}


const Gift = ({ messages, lang } : IProps) => {

  const giftDefault = lang === 'ko-KR' ? 'toss' : 'btc';

  const [giftState, giftSet] = useState(giftDefault);

  return (
    <Wrap>
      <Title>Wedding Gift</Title>
      <GiftTab>
        {lang === 'ko-KR' && <li><GiftBtn type="button" shape={'money'} onClick={() => giftSet('toss')}>{messages.money}</GiftBtn></li> }
        <li><GiftBtn type="button" shape={'btc'} onClick={() => giftSet('btc')}>BTC</GiftBtn></li>
        <li><GiftBtn type="button" shape={'ht'} onClick={() => giftSet('ht')}>HT</GiftBtn></li>
      </GiftTab>
      <Section>
        { giftState === 'toss' ? <Toss messages={messages} /> : giftState === 'btc' ?
          <Coin lang={lang} messages={messages} coinname={'btc'} qrcode={'1AfTuKL6rZ5atTgJgh6NxdS2bqK4RZHiVW'} /> : <Coin lang={lang} messages={messages} coinname={'ht'} qrcode={'0x3a1bf90566c350f29baa3db520dd9d11d6007e29'} />
        }
      </Section>
      <Flower shape={'top'} />
      <Flower shape={'bottom'} />
    </Wrap>
  );
}

export default Gift;


// WEBPACK FOOTER //
// ./src/components/gift/index.tsx